var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.72891 12.7461C2.02064 11.8259 1.6665 11.3658 1.6665 9.99967C1.6665 8.63351 2.02064 8.17345 2.72891 7.25328C4.14314 5.41597 6.51493 3.33301 9.99984 3.33301C13.4848 3.33301 15.8565 5.41597 17.2708 7.25328C17.979 8.17345 18.3332 8.63351 18.3332 9.99967C18.3332 11.3658 17.979 11.8259 17.2708 12.7461C15.8565 14.5833 13.4848 16.6663 9.99984 16.6663C6.51493 16.6663 4.14314 14.5833 2.72891 12.7461Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61925 12.5 7.5 11.3807 7.5 10C7.5 8.61925 8.61925 7.5 10 7.5C11.3807 7.5 12.5 8.61925 12.5 10Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/EYE.66bf6cbd498113ec839478eb65726ff5.svg";
export { ForwardRef as ReactComponent };